module.exports = __webpack_public_path__ + "src/img/time.00218def.svg";